var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2694 6.60576C23.6841 6.21293 24.236 5.99575 24.8086 6.00006C25.3812 6.00437 25.9298 6.22983 26.3385 6.62886C26.7472 7.02789 26.9841 7.56929 26.9992 8.1388C27.0144 8.70832 26.8065 9.26141 26.4196 9.68137L14.6726 24.2979C14.4706 24.5143 14.2268 24.688 13.9558 24.8086C13.6848 24.9292 13.3921 24.9942 13.0953 24.9996C12.7984 25.0051 12.5035 24.951 12.2282 24.8404C11.9529 24.7299 11.7028 24.5653 11.4929 24.3564L3.70279 16.6059C3.48584 16.4048 3.31184 16.1622 3.19115 15.8928C3.07047 15.6233 3.00557 15.3324 3.00034 15.0374C2.99511 14.7424 3.04965 14.4494 3.16071 14.1759C3.27176 13.9023 3.43706 13.6538 3.64673 13.4452C3.85641 13.2366 4.10617 13.0722 4.38112 12.9617C4.65606 12.8512 4.95056 12.7969 5.24704 12.8021C5.54352 12.8073 5.83591 12.8719 6.10677 12.992C6.37763 13.112 6.6214 13.2852 6.82355 13.501L12.9885 19.6317L23.2134 6.6702C23.2319 6.64765 23.2515 6.62613 23.2723 6.60576H23.2694Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4c0002ffc5e9c3863ba0bb6898579a62.svg";
export { ForwardRef as ReactComponent };